<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
import { fetchUserInfo } from '@/api/user'
import { userLogin } from '@/api/login'
import { reInitInstance } from '@/api/index'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  created() {
    /**
     * session에 userKey 존재 유무에 따라 분기
     * 1. session 에 user_key 가 있을경우 store에 userInfo가 있으면 pass
     *    없을경우 getUserInfo() 호출하여 store 에 userInfo 저장
     * 2. session 에 user_key 가 없을 경우 cookie의 user_key 유무에 따라 분기
     *   a. cookie 에 user_key가 없을경우
     *     - mode: product (release) => 로그인 url 로 redirect
     *     - mode: develoment (dev) => 정해진 userId, password 로 로그인 api 호출
     *       해서 user_key 생성
     *   b. cookie 에 user_key가 있을경우
     *     - this.$cookies.get("user_key") 로 user_key 쿠키에서 유저키 생성
     *   c. "a" or "b" 과정이후 getUserInfo() 호출하여 store 에 userInfo 저장
     */
  
    console.log(window.location);
    if(window.location.pathname == "/gate") return;
    if(this.$router.history.current.path == "/gate") return;
    if(this.$router.history.current.path == "/login") return;
    if(this.$router.history.current.path == "/maintanence") return; // dev

    if(this.$route.query.id != undefined){
      if(this.$route.query.k != "fce94681d16059ed"){
        this.$router.push('/login')
        return;
      }
      const userId = this.$route.query.id;
      const password = this.$route.query.pass;
      userLogin({
        userId, password
      }).then((res) => {
        sessionStorage.setItem('userKey', res.data.userKey)
        reInitInstance();
        var userKey = res.data.userKey;
        fetchUserInfo({
          userKey
        }, {
          headers: {
            userKey
          }
        }).then((res) => {
          //console.log(res);
          this.$store.state.userInfo = res.data.userInfo;
          this.$router.push('/main')
        })
      });
      return;
    }

    if(sessionStorage.getItem('userKey')) {
      //console.log("session has userKey")
      var app_version = sessionStorage.getItem("app_version");
      if(app_version){
        this.$store.state.appVersion = app_version;
      }
      var report_users = this.$cookies.get("report_users");
      if(report_users){
        this.$store.state.report_users = JSON.parse(report_users);
        console.log("=================1");
        console.log("saved",this.$store.state.report_users);
        this.$store.commit('udtReportUser', JSON.parse(report_users));
        //window.VueRoot.$store.commit('udtReportUser', JSON.parse(report_users));
      }

      if(this.$store.state.userInfo.uniqId){
        //console.log("has store.state.userInfo")
      } else {
        this.getUserInfo(sessionStorage.getItem('userKey'));
      }
    } else {
      /* debug check loggin mobile cookie
      console.log("===================")
      console.log(JSON.stringify(this.$cookies.keys()))
      */
      const c_user_key = this.$cookies.get("user_key");
      if(c_user_key == null){
        this.$router.replace({
          path: "/login",
          query: { from: "app" },
        });
      }else{
        sessionStorage.setItem('userKey', c_user_key)
        const app_version = this.$cookies.get("app_version");
        if(app_version != null){
          sessionStorage.setItem("app_version",app_version);
          this.$store.state.appVersion = app_version;
        }

        const report_users = this.$cookies.get("report_users");
        if(report_users){
          console.log("=================2");
          console.log(report_users);
          this.$store.state.report_users = JSON.parse(report_users);
        }

        reInitInstance();
        this.getUserInfo(c_user_key);
      }
    }
  },

  methods: {
        /**
     * info.do api를 호출해서 vue store 에 return 된 userInfo 저장
     * 
     * @user_key = login api 호출하여 받은 token
     * from api, session, cookie
     */
    getUserInfo(userKey){
      fetchUserInfo({
        userKey
      }, {
        headers: {
          userKey
        }
      }).then((res) => {
        if(this.$store.state.appVersion != "90.90.90"){
          if(res.data.serverCheck == "Y"){
            this.$router.push('/maintenance')
            return;
          }
        }
        
        this.$store.state.userInfo = res.data.userInfo;
      })
    }
  },
};

</script>
